import { getCurrentUser } from '@/plugins/stitch'
import router from '@/router'

window.zE(() => {
  window.$zopim(() => {
    setTimeout(() => {
      document.getElementById('webWidget').contentWindow.document.body.onclick = delegateArticleLinks
    }, 3000)

    const user = getCurrentUser()

    if (user) {
      window.$zopim.livechat.setName(
        `${user.profile.firstName || ''} ${user.profile.lastName || ''}`.trim()
      )
      window.$zopim.livechat.setEmail(user.profile.email)
      window.$zopim.livechat.setNotes(`User ID: ${user.id}`)
    }
  })
})

function delegateArticleLinks ($event) {
  // ensure we use the link, in case the click has been received by a subelement
  let { target } = $event
  while (target && target.tagName !== 'A') target = target.parentNode
  // handle only links that do not reference external resources
  // target.matches("a:not([href*='://'])") &&
  if (target && target.href) {
    // some sanity checks taken from vue-router:
    // https://github.com/vuejs/vue-router/blob/dev/src/components/link.js#L106
    const { altKey, ctrlKey, metaKey, shiftKey, button, defaultPrevented } = event
    // don't handle with control keys
    if (metaKey || altKey || ctrlKey || shiftKey) return
    // don't handle when preventDefault called
    if (defaultPrevented) return
    // don't handle right clicks
    if (button !== undefined && button !== 0) return

    const url = new URL(target.href)

    // only handle app links
    if (url.host !== 'manage.project-atlas.app') return

    const to = url.pathname
    if (event.preventDefault) {
      event.preventDefault()
      // If you're not on the route already, go there otherwise do nothing
      if (window.location.pathname !== to) {
        router.push(to)
      }
    }
  }
}
